import collisionJson from '@/assets/generated/world/meadow/meadow-collision.json';
import zonesJson from '@/assets/generated/world/meadow/meadow-zones.json';
import type { CollisionShape } from '../geometry';
import type { RegionZone } from '../region-definition';
import { translatedRegionData, type SerializedMapData, type SerializedZoneData } from './region-map-data';

const data = translatedRegionData(
  collisionJson as unknown as SerializedMapData,
  zonesJson as unknown as SerializedZoneData,
  0,
  0,
  2,
);
export const MEADOW_COLLISION: readonly CollisionShape[] = data.collision;
export const MEADOW_ZONES: readonly RegionZone[] = data.zones;
